export default "__VITE_ASSET__DvNRIWxf__"